import { convertLocale } from '@pe-libs/react-components/build/lib/helper';
import { NextPage } from 'next';
import React from 'react';
import { getQueryParameters } from '#helpers/query';
import { setUserIntl } from '#modules/app/actions/settings';
import { profilePublicDetailsRequested } from '#modules/defaultLandingReferral/actions';
import DefaultThankYouPage from '#modules/defaultLandingReferral/components/DefaultSurveyThankYouPage';
import { getParameters } from '#modules/defaultLandingReferral/components/DefaultSurveyThankYouPage/helper';
import { wrapper } from '../../store';
import { StateType } from '../../types';

type Props = {
  state: StateType;
};

const DefaultSurveyThankYouPage: NextPage<Props> = () => <DefaultThankYouPage />;

DefaultSurveyThankYouPage.getInitialProps = wrapper.getInitialPageProps((store) => async (context) => {
  const lang = getQueryParameters(context.query, 'lang');
  const locale = convertLocale(lang, 'locale');
  const { profile, profileId } = getParameters(context.query);

  store.dispatch(setUserIntl({ locale }));
  await store.dispatch(profilePublicDetailsRequested({ profileId: profile || profileId }));

  return { props: {} };
});

export default DefaultSurveyThankYouPage;
